<app-elevation-section [title]="languageService.LNG('Label.Product')" [removeMargin]="allowEdit">
    <dx-data-grid
      #datagriddx
      class="pointer"
      [dataSource]="carrierItemFlows"
      [rowAlternationEnabled]="true"
      [showBorders]="true"
      [columnAutoWidth]="true"
      (onEditorPreparing)="onEditorPreparing($event)"
      (onEditingStart)="onEditingStart($event)"
      (onSaving)="onSavingMultiple($event)"
      (onInitNewRow)="onInitNewRow($event)"
      (onToolbarPreparing)="onToolbarPreparing($event)"
      height="325">

      <dxo-editing
        mode="batch"
        [allowUpdating]="allowEdit"
        [allowAdding]="allowEdit"
        [useIcons]="true"
      >
      </dxo-editing>
      <dxo-grouping #expand [autoExpandAll]="true"></dxo-grouping>
      <dxo-scrolling mode="virtual"></dxo-scrolling>
      <dxo-paging [pageSize]="10"></dxo-paging>
      <dxo-selection mode="multiple" showCheckBoxesMode="always"> </dxo-selection>
      <dxi-column
        dataField="ArticleId"
        caption="{{ languageService.LNG('Label.Article') }}"
      >
        <dxo-lookup
          [dataSource]="items"
          valueExpr="ArticleId"
          displayExpr="ArticleName"
        ></dxo-lookup>
      </dxi-column>
      <dxi-column
        dataField="Number"
        caption="{{ languageService.LNG('Label.Value') }}"
        dataType="number"
        [width]="75"
      ></dxi-column>
      <dxi-column
        dataField="UnitDescription"
        caption="{{ languageService.LNG('Label.Unit') }}"
        [allowEditing]="false"
        [width]="50"
      ></dxi-column>

    </dx-data-grid>
  </app-elevation-section>
